import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// Components
import Hero from "@home/Hero";
import TopFund from "@home/TopFund";
import MyNft from "@home/MyNft";
import HowUnique from "@home/HowUnique";
import Wagmi from "@home/Wagmi";

const Home = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Handle token redirect if present in URL
  useEffect(() => {
    const tokenId = searchParams.get("tokenId");
    if (tokenId) {
      navigate(`/buy/${tokenId}`, { replace: true });
    }
  }, [searchParams, navigate]);

  // Don't render if redirecting
  const tokenId = searchParams.get("tokenId");
  if (tokenId) {
    return null;
  }

  return (
    <main className="home-page">
      <Hero />
      <TopFund />
      <MyNft />
      <HowUnique />
      <Wagmi />
    </main>
  );
};

export default Home;
